import { Navigate } from "react-router-dom";
import { useAuth } from "./auth";

export function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen bg-[#FFFFFF] flex items-center justify-center">
        <div className="w-10 h-10 rounded-full border-2 border-[#AC9667]/30 border-t-[#AC9667] animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/auth" replace />;
  if (roles && !roles.includes(user.role)) {
    // Send user to their proper portal
    const dest = user.role === "admin" ? "/admin" : user.role === "caregiver" ? "/caregiver" : "/client";
    return <Navigate to={dest} replace />;
  }
  return children;
}
